export default "__VITE_ASSET__q4ZONh1h__"